// Backend: GET /api/sales  GET /api/invoices

export type PaymentStatus = 'paid' | 'partial' | 'unpaid' | 'overdue' | 'cancelled';
export type SaleType = 'eggs' | 'broilers' | 'layers' | 'chicks' | 'manure' | 'other';
export type InvoiceStatus = 'draft' | 'sent' | 'paid' | 'partial' | 'overdue' | 'cancelled';

export interface SaleLineItem {
  id: string;
  productType: SaleType;
  description: string;
  quantity: number;
  unit: string;
  unitPrice: number;
  totalPrice: number;
}

export interface SaleRecord {
  id: string;
  invoiceNumber: string;
  date: string;
  dueDate: string;
  farm: string;
  branch: string;
  customerId: string;
  customerName: string;
  customerPhone: string;
  customerAddress: string;
  lineItems: SaleLineItem[];
  subtotal: number;
  discount: number;
  tax: number;
  totalAmount: number;
  amountPaid: number;
  balance: number;
  paymentStatus: PaymentStatus;
  invoiceStatus: InvoiceStatus;
  paymentMethod: string;
  notes: string;
  createdBy: string;
}

export interface Customer {
  id: string;
  name: string;
  phone: string;
  email: string;
  address: string;
  type: 'individual' | 'business' | 'wholesale' | 'retail';
  totalPurchases: number;
  outstandingBalance: number;
}

export const MOCK_CUSTOMERS: Customer[] = [
  { id: 'cust-001', name: 'Kampala Fresh Markets Ltd', phone: '+256 772 111 222', email: 'orders@kampalamarkets.ug', address: 'Nakasero Market, Kampala', type: 'wholesale', totalPurchases: 48500000, outstandingBalance: 2400000 },
  { id: 'cust-002', name: 'Owino Supermarket', phone: '+256 701 333 444', email: 'procurement@owino.ug', address: 'Owino Market, Kampala', type: 'retail', totalPurchases: 18200000, outstandingBalance: 0 },
  { id: 'cust-003', name: 'Mr. David Ssemakula', phone: '+256 756 555 666', email: '', address: 'Mukono Town', type: 'individual', totalPurchases: 4800000, outstandingBalance: 750000 },
  { id: 'cust-004', name: 'Jinja Poultry Traders', phone: '+256 782 777 888', email: 'jinja.poultry@gmail.com', address: 'Jinja Main Street', type: 'wholesale', totalPurchases: 31000000, outstandingBalance: 5100000 },
  { id: 'cust-005', name: 'Entebbe Hotel & Suites', phone: '+256 414 999 000', email: 'kitchen@entebbehotel.ug', address: 'Entebbe Road', type: 'business', totalPurchases: 12600000, outstandingBalance: 0 },
  { id: 'cust-006', name: 'Ms. Grace Nakato', phone: '+256 703 121 314', email: '', address: 'Iganga Town', type: 'individual', totalPurchases: 1200000, outstandingBalance: 0 },
];

export const MOCK_SALES: SaleRecord[] = [
  {
    id: 'sale-001',
    invoiceNumber: 'INV-2026-0041',
    date: '2026-09-01',
    dueDate: '2026-09-15',
    farm: 'Idudi Poultry Farm',
    branch: 'Idudi Main Site',
    customerId: 'cust-001',
    customerName: 'Kampala Fresh Markets Ltd',
    customerPhone: '+256 772 111 222',
    customerAddress: 'Nakasero Market, Kampala',
    lineItems: [
      { id: 'li-001a', productType: 'eggs', description: 'Tray Eggs (30 eggs/tray)', quantity: 200, unit: 'trays', unitPrice: 18000, totalPrice: 3600000 },
      { id: 'li-001b', productType: 'broilers', description: 'Live Broilers (avg 2.4 kg)', quantity: 120, unit: 'birds', unitPrice: 22000, totalPrice: 2640000 },
    ],
    subtotal: 6240000,
    discount: 240000,
    tax: 0,
    totalAmount: 6000000,
    amountPaid: 3600000,
    balance: 2400000,
    paymentStatus: 'partial',
    invoiceStatus: 'sent',
    paymentMethod: 'Mobile Money',
    notes: 'Partial payment received on delivery. Balance due 15 Sep.',
    createdBy: 'Sarah Namukasa',
  },
  {
    id: 'sale-002',
    invoiceNumber: 'INV-2026-0040',
    date: '2026-08-28',
    dueDate: '2026-09-11',
    farm: 'Kampala Demonstration Farm',
    branch: 'Kawanda Layer Unit',
    customerId: 'cust-005',
    customerName: 'Entebbe Hotel & Suites',
    customerPhone: '+256 414 999 000',
    customerAddress: 'Entebbe Road',
    lineItems: [
      { id: 'li-002a', productType: 'eggs', description: 'Tray Eggs (30 eggs/tray)', quantity: 80, unit: 'trays', unitPrice: 19000, totalPrice: 1520000 },
    ],
    subtotal: 1520000,
    discount: 0,
    tax: 0,
    totalAmount: 1520000,
    amountPaid: 1520000,
    balance: 0,
    paymentStatus: 'paid',
    invoiceStatus: 'paid',
    paymentMethod: 'Bank Transfer',
    notes: '',
    createdBy: 'Dr. Grace Atim',
  },
  {
    id: 'sale-003',
    invoiceNumber: 'INV-2026-0039',
    date: '2026-08-25',
    dueDate: '2026-09-08',
    farm: 'Idudi Poultry Farm',
    branch: 'Idudi Extension Site',
    customerId: 'cust-004',
    customerName: 'Jinja Poultry Traders',
    customerPhone: '+256 782 777 888',
    customerAddress: 'Jinja Main Street',
    lineItems: [
      { id: 'li-003a', productType: 'broilers', description: 'Live Broilers (avg 2.5 kg)', quantity: 300, unit: 'birds', unitPrice: 23000, totalPrice: 6900000 },
      { id: 'li-003b', productType: 'chicks', description: 'Day-Old Chicks (Cobb 500)', quantity: 500, unit: 'chicks', unitPrice: 2800, totalPrice: 1400000 },
    ],
    subtotal: 8300000,
    discount: 0,
    tax: 0,
    totalAmount: 8300000,
    amountPaid: 3200000,
    balance: 5100000,
    paymentStatus: 'overdue',
    invoiceStatus: 'overdue',
    paymentMethod: 'Cash',
    notes: 'Overdue — follow up required.',
    createdBy: 'Peter Waiswa',
  },
  {
    id: 'sale-004',
    invoiceNumber: 'INV-2026-0038',
    date: '2026-08-20',
    dueDate: '2026-09-03',
    farm: 'Idudi Poultry Farm',
    branch: 'Idudi Main Site',
    customerId: 'cust-002',
    customerName: 'Owino Supermarket',
    customerPhone: '+256 701 333 444',
    customerAddress: 'Owino Market, Kampala',
    lineItems: [
      { id: 'li-004a', productType: 'eggs', description: 'Tray Eggs (30 eggs/tray)', quantity: 150, unit: 'trays', unitPrice: 18500, totalPrice: 2775000 },
    ],
    subtotal: 2775000,
    discount: 75000,
    tax: 0,
    totalAmount: 2700000,
    amountPaid: 2700000,
    balance: 0,
    paymentStatus: 'paid',
    invoiceStatus: 'paid',
    paymentMethod: 'Cash',
    notes: '',
    createdBy: 'Sarah Namukasa',
  },
  {
    id: 'sale-005',
    invoiceNumber: 'INV-2026-0037',
    date: '2026-08-18',
    dueDate: '2026-09-01',
    farm: 'Idudi Poultry Farm',
    branch: 'Idudi Main Site',
    customerId: 'cust-003',
    customerName: 'Mr. David Ssemakula',
    customerPhone: '+256 756 555 666',
    customerAddress: 'Mukono Town',
    lineItems: [
      { id: 'li-005a', productType: 'layers', description: 'Point-of-Lay Hens (18 weeks)', quantity: 50, unit: 'birds', unitPrice: 35000, totalPrice: 1750000 },
    ],
    subtotal: 1750000,
    discount: 0,
    tax: 0,
    totalAmount: 1750000,
    amountPaid: 1000000,
    balance: 750000,
    paymentStatus: 'partial',
    invoiceStatus: 'sent',
    paymentMethod: 'Mobile Money',
    notes: 'Balance to be paid on next delivery.',
    createdBy: 'Sarah Namukasa',
  },
  {
    id: 'sale-006',
    invoiceNumber: 'INV-2026-0036',
    date: '2026-08-15',
    dueDate: '2026-08-29',
    farm: 'Kampala Demonstration Farm',
    branch: 'Kawanda Layer Unit',
    customerId: 'cust-006',
    customerName: 'Ms. Grace Nakato',
    customerPhone: '+256 703 121 314',
    customerAddress: 'Iganga Town',
    lineItems: [
      { id: 'li-006a', productType: 'eggs', description: 'Tray Eggs (30 eggs/tray)', quantity: 30, unit: 'trays', unitPrice: 18000, totalPrice: 540000 },
      { id: 'li-006b', productType: 'manure', description: 'Poultry Manure (50 kg bag)', quantity: 10, unit: 'bags', unitPrice: 15000, totalPrice: 150000 },
    ],
    subtotal: 690000,
    discount: 0,
    tax: 0,
    totalAmount: 690000,
    amountPaid: 690000,
    balance: 0,
    paymentStatus: 'paid',
    invoiceStatus: 'paid',
    paymentMethod: 'Cash',
    notes: '',
    createdBy: 'Dr. Grace Atim',
  },
];

export const PAYMENT_STATUS_STYLES: Record<PaymentStatus, { bg: string; text: string; label: string }> = {
  paid:      { bg: 'bg-green-100',  text: 'text-green-700',  label: 'Paid' },
  partial:   { bg: 'bg-amber-100',  text: 'text-amber-700',  label: 'Partial' },
  unpaid:    { bg: 'bg-gray-100',   text: 'text-gray-600',   label: 'Unpaid' },
  overdue:   { bg: 'bg-red-100',    text: 'text-red-700',    label: 'Overdue' },
  cancelled: { bg: 'bg-gray-100',   text: 'text-gray-400',   label: 'Cancelled' },
};

export const INVOICE_STATUS_STYLES: Record<InvoiceStatus, { bg: string; text: string; label: string }> = {
  draft:     { bg: 'bg-gray-100',   text: 'text-gray-600',   label: 'Draft' },
  sent:      { bg: 'bg-blue-100',   text: 'text-blue-700',   label: 'Sent' },
  paid:      { bg: 'bg-green-100',  text: 'text-green-700',  label: 'Paid' },
  partial:   { bg: 'bg-amber-100',  text: 'text-amber-700',  label: 'Partial' },
  overdue:   { bg: 'bg-red-100',    text: 'text-red-700',    label: 'Overdue' },
  cancelled: { bg: 'bg-gray-100',   text: 'text-gray-400',   label: 'Cancelled' },
};

export const SALE_TYPE_LABELS: Record<SaleType, string> = {
  eggs:     'Eggs',
  broilers: 'Broilers',
  layers:   'Layers / POL Hens',
  chicks:   'Day-Old Chicks',
  manure:   'Poultry Manure',
  other:    'Other',
};

export const FARMS_LIST = [
  { id: 'farm-001', name: 'Idudi Poultry Farm', branches: ['Idudi Main Site', 'Idudi Extension Site'] },
  { id: 'farm-002', name: 'Kampala Demonstration Farm', branches: ['Kawanda Layer Unit'] },
  { id: 'farm-003', name: 'Mbarara Broiler Farm', branches: [] },
];

export const PAYMENT_METHODS = ['Cash', 'Mobile Money', 'Bank Transfer', 'Cheque', 'Credit'];

export function formatUGX(amount: number): string {
  return 'UGX ' + amount.toLocaleString();
}
